<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

// "Dados da mensagem": who read it, who only received it, who hasn't yet.
const props = defineProps({
  receipts: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const dialogRef = ref(null);
const message = ref(null);

const groups = computed(() => {
  if (!message.value) return [];
  const at = message.value.created_at;
  const recipients = Object.values(props.receipts)
    .filter(receipt => receipt.user_id !== message.value.user_id)
    .sort((a, b) => a.name.localeCompare(b.name));
  const read = recipients.filter(receipt => (receipt.last_read_at || 0) >= at);
  const delivered = recipients.filter(
    receipt =>
      !read.includes(receipt) && (receipt.last_delivered_at || 0) >= at
  );
  const waiting = recipients.filter(
    receipt => !read.includes(receipt) && !delivered.includes(receipt)
  );
  return [
    {
      key: 'read',
      title: t('TEAM_CHAT.RECEIPTS.READ_BY'),
      icon: 'i-lucide-check-check text-n-blue-10',
      people: read,
    },
    {
      key: 'delivered',
      title: t('TEAM_CHAT.RECEIPTS.DELIVERED_TO'),
      icon: 'i-lucide-check-check text-n-slate-10',
      people: delivered,
    },
    {
      key: 'waiting',
      title: t('TEAM_CHAT.RECEIPTS.WAITING'),
      icon: 'i-lucide-check text-n-slate-10',
      people: waiting,
    },
  ].filter(group => group.people.length);
});

const open = item => {
  message.value = item;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('TEAM_CHAT.RECEIPTS.INFO_TITLE')"
    :cancel-button-label="t('TEAM_CHAT.RECEIPTS.CLOSE')"
    :show-confirm-button="false"
    width="md"
    overflow-y-auto
  >
    <div class="flex flex-col gap-4">
      <section v-for="group in groups" :key="group.key">
        <h4
          class="flex items-center gap-1.5 mb-2 text-sm font-medium text-n-slate-12"
        >
          <span class="size-4" :class="group.icon" />
          {{ group.title }}
          <span class="text-n-slate-10">· {{ group.people.length }}</span>
        </h4>
        <ul class="flex flex-col gap-1.5">
          <li
            v-for="person in group.people"
            :key="person.user_id"
            class="flex items-center gap-2 text-sm text-n-slate-12"
          >
            <Avatar
              :src="person.avatar_url"
              :name="person.name"
              :size="24"
              rounded-full
            />
            {{ person.name }}
          </li>
        </ul>
      </section>
    </div>
  </Dialog>
</template>
